import React from "react";
import { Link } from "react-router-dom";

/**
 * Catch-all for unmatched routes.
 *
 * Without one, React Router matched nothing and rendered an empty document
 * a mistyped or stale link produced a blank white page with no way back. A
 * blank page is indistinguishable from a broken app, which is a bad thing for
 * a customer to see on a page that holds their money.
 */
const NotFound = () => (
  <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
    <div
      className="text-center p-5 rounded-4"
      style={{
        maxWidth: 440,
        border: "1px solid #e2e8f0",
        boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
      }}
    >
      <div style={{ fontSize: 44, marginBottom: 12 }}>🧭</div>
      <h2 className="fs-4 fw-bold mb-2" style={{ color: "#0f172a" }}>
        Page not found
      </h2>
      <p className="text-muted mb-4" style={{ fontSize: 15 }}>
        The page you're looking for doesn't exist or has moved. Your account and
        balances are unaffected.
      </p>
      <div className="d-flex flex-column gap-2">
        <Link to="/dashboard" className="btn btn-success">
          Go to dashboard
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
